export function getNiceStep(min, max, ticks) {
    const range = max - min;
    if (range === 0) return 1;

    const roughStep = range / (ticks - 1);
    const pow10 = Math.pow(10, Math.floor(Math.log10(roughStep)));
    const fraction = roughStep / pow10;

    let niceFraction;
    if (fraction <= 1) niceFraction = 1;
    else if (fraction <= 2) niceFraction = 2;
    else if (fraction <= 5) niceFraction = 5;
    else niceFraction = 10;

    return niceFraction * pow10;
}

export function getNiceDomain(min, max, ticks) {
    const step = getNiceStep(min, max, ticks);
    return [
        Math.floor(min / step) * step,
        Math.ceil(max / step) * step,
    ];
}
